/* tslint:disable */
/* eslint-disable */
/**
 * FreightSimple Hubble API
 * No description provided (generated by Openapi Generator https://github.com/openapitools/openapi-generator)
 *
 * The version of the OpenAPI document: 0.0
 *
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */

import { mapValues } from "../runtime";
import type { IntegrationCheckStatus } from "./IntegrationCheckStatus";
import {
  IntegrationCheckStatusFromJSON,
  IntegrationCheckStatusFromJSONTyped,
  IntegrationCheckStatusToJSON,
  IntegrationCheckStatusToJSONTyped,
} from "./IntegrationCheckStatus";
import type { ShopifyHealthcheckOffender } from "./ShopifyHealthcheckOffender";
import {
  ShopifyHealthcheckOffenderFromJSON,
  ShopifyHealthcheckOffenderFromJSONTyped,
  ShopifyHealthcheckOffenderToJSON,
  ShopifyHealthcheckOffenderToJSONTyped,
} from "./ShopifyHealthcheckOffender";
import type { IntegrationCheckOwner } from "./IntegrationCheckOwner";
import {
  IntegrationCheckOwnerFromJSON,
  IntegrationCheckOwnerFromJSONTyped,
  IntegrationCheckOwnerToJSON,
  IntegrationCheckOwnerToJSONTyped,
} from "./IntegrationCheckOwner";

/**
 *
 * @export
 * @interface ShopifyHealthcheckItem
 */
export interface ShopifyHealthcheckItem {
  /**
   *
   * @type {string}
   * @memberof ShopifyHealthcheckItem
   */
  id: string;
  /**
   *
   * @type {string}
   * @memberof ShopifyHealthcheckItem
   */
  name: string;
  /**
   *
   * @type {IntegrationCheckStatus}
   * @memberof ShopifyHealthcheckItem
   */
  status: IntegrationCheckStatus;
  /**
   *
   * @type {string}
   * @memberof ShopifyHealthcheckItem
   */
  detail: string;
  /**
   *
   * @type {IntegrationCheckOwner}
   * @memberof ShopifyHealthcheckItem
   */
  owner: IntegrationCheckOwner;
  /**
   *
   * @type {string}
   * @memberof ShopifyHealthcheckItem
   */
  merchantDetail?: string | null;
  /**
   *
   * @type {boolean}
   * @memberof ShopifyHealthcheckItem
   */
  inferred: boolean;
  /**
   *
   * @type {boolean}
   * @memberof ShopifyHealthcheckItem
   */
  dimensionsInShopify: boolean;
  /**
   *
   * @type {Array<ShopifyHealthcheckOffender>}
   * @memberof ShopifyHealthcheckItem
   */
  offenders: Array<ShopifyHealthcheckOffender>;
}

/**
 * Check if a given object implements the ShopifyHealthcheckItem interface.
 */
export function instanceOfShopifyHealthcheckItem(
  value: object,
): value is ShopifyHealthcheckItem {
  if (!("id" in value) || value["id"] === undefined) return false;
  if (!("name" in value) || value["name"] === undefined) return false;
  if (!("status" in value) || value["status"] === undefined) return false;
  if (!("detail" in value) || value["detail"] === undefined) return false;
  if (!("owner" in value) || value["owner"] === undefined) return false;
  if (!("inferred" in value) || value["inferred"] === undefined) return false;
  if (
    !("dimensionsInShopify" in value) ||
    value["dimensionsInShopify"] === undefined
  )
    return false;
  if (!("offenders" in value) || value["offenders"] === undefined) return false;
  return true;
}

export function ShopifyHealthcheckItemFromJSON(
  json: any,
): ShopifyHealthcheckItem {
  return ShopifyHealthcheckItemFromJSONTyped(json, false);
}

export function ShopifyHealthcheckItemFromJSONTyped(
  json: any,
  ignoreDiscriminator: boolean,
): ShopifyHealthcheckItem {
  if (json == null) {
    return json;
  }
  return {
    id: json["id"],
    name: json["name"],
    status: IntegrationCheckStatusFromJSON(json["status"]),
    detail: json["detail"],
    owner: IntegrationCheckOwnerFromJSON(json["owner"]),
    merchantDetail:
      json["merchantDetail"] == null ? undefined : json["merchantDetail"],
    inferred: json["inferred"],
    dimensionsInShopify: json["dimensionsInShopify"],
    offenders: (json["offenders"] as Array<any>).map(
      ShopifyHealthcheckOffenderFromJSON,
    ),
  };
}

export function ShopifyHealthcheckItemToJSON(
  json: any,
): ShopifyHealthcheckItem {
  return ShopifyHealthcheckItemToJSONTyped(json, false);
}

export function ShopifyHealthcheckItemToJSONTyped(
  value?: ShopifyHealthcheckItem | null,
  ignoreDiscriminator: boolean = false,
): any {
  if (value == null) {
    return value;
  }

  return {
    id: value["id"],
    name: value["name"],
    status: IntegrationCheckStatusToJSON(value["status"]),
    detail: value["detail"],
    owner: IntegrationCheckOwnerToJSON(value["owner"]),
    merchantDetail: value["merchantDetail"],
    inferred: value["inferred"],
    dimensionsInShopify: value["dimensionsInShopify"],
    offenders: (value["offenders"] as Array<any>).map(
      ShopifyHealthcheckOffenderToJSON,
    ),
  };
}
